import React from "react";

/**
 * ECLNumber returns either an input or a label/input component for numbers.
 *
 * @export
 * @param {Object} props
 *    -name - string - provide a name to place a label above the input.
 *    -id - string - provide an ID to allow for lookup of value on form submission
 *    -precision - number - provide a positive integer to allow x places of precision (i.e. .001 is precision=3)
 *          if not provided, step defaults to one.
 *    -min - number - provides a lower bounds that will be validated on form submission
 *    -max - number - provide an upper bounds
 *    -labelwidth - number - size offset of the label ??? (Better way?)
 *    -placeholder - string - optional placeholder text
 *    -required - bool - is this a required input?
 *    -onChange - function - function that is bound to the inputs onChange function (so (e) => {...do stuff})
 * @return {ReactComponent}
 */
export default function ECLNumber(props) {
   return props.name ? (
      <>
         <label htmlFor={props.id}>
            {props.name}{" "}
            {props.required && <span className="required-input">*</span>}
         </label>
         <input
            className="ecl-input"
            id={props.id}
            type="number"
            step={props.precision ? 1 / Math.pow(10, props.precision) : 1}
            min={props.min}
            max={props.max}
            style={
               props.labelWidth && {
                  width: "calc(100% - " + props.labelWidth + "px)",
               }
            }
            defaultValue={props.value}
            value={props.stateValue}
            onChange={props.onChange}
            placeholder={props.placeholder ? props.placeholder : " "}
            required={props.required}
            tabIndex={props.tabIndex}
         />
      </>
   ) : (
      <>
         <input
            className="ecl-input"
            id={props.id}
            type="number"
            step={props.precision ? 1 / Math.pow(10, props.precision) : 1}
            min={props.min}
            max={props.max}
            style={
               props.labelWidth && {
                  width: "calc(100% - " + props.labelWidth + "px)",
               }
            }
            defaultValue={props.value}
            value={props.stateValue}
            onChange={props.onChange}
            placeholder={props.placeholder ? props.placeholder : " "}
            required={props.required}
            tabIndex={props.tabIndex}
         />
      </>
   );
}
